export interface TopicCategory {
  id: string;
  name: string;
  rank?: number;
  trainingId: string;
}

export type TopicCategoryFormData = Omit<TopicCategory, "id" | "rank">;

export const emptyTopicCategory = (
  trainingId: string,
): TopicCategoryFormData => ({
  name: "",
  trainingId,
});
